import {
	Table as BaseTable,
	Button,
	Spinner,
	type TableProps,
} from "@heroui/react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { type AppFormApi, useLanguage } from "@onesolution/hooks";
import type { TranslationsKeys } from "@onesolution/hooks/useLanguage";

export default function Table(
	props: TableProps & {
		hasNextPage: boolean;
		isFetching: boolean;
		fetchNextPage?: () => unknown;
	},
) {
	const { t } = useLanguage();

	return (
		<div className="max-w-screen-3xl mx-auto w-full flex relative rounded-large overflow-hidden">
			<BaseTable
				isHeaderSticky
				classNames={{
					th: "sticky top-0 z-10 bg-content2",
					...(props.classNames || {}),
				}}
				bottomContent={
					props.hasNextPage && props.fetchNextPage ? (
						<div className="flex w-full justify-center">
							<Button
								isDisabled={props.isFetching}
								variant="flat"
								onPress={() => props.fetchNextPage!()}
							>
								{props.isFetching && <Spinner color="primary" size="sm" />}
								{t("basic.load-more")}
							</Button>
						</div>
					) : null
				}
				{...props}
			>
				{props.children}
			</BaseTable>
			<div className="absolute left-0 min-w-full h-4 bg-background top-0" />
		</div>
	);
}

export const baseTableBodyProps = (
	t: (s: TranslationsKeys) => string,
	form?: AppFormApi,
) => {
	const formTyped = form as unknown as { resetForm: () => void };
	return {
		loadingContent: (
			<div className="w-full z-30 flex items-center justify-center">
				<Spinner size="lg" color="primary" />
			</div>
		),
		emptyContent: (
			<div className="flex gap-4 flex-col">
				<span className="font-bold text-2xl">{t("message.nothing")}</span>
				{form && (
					<Button
						variant="solid"
						color="primary"
						onPress={formTyped.resetForm}
						startContent={
							<Icon icon="solar:filter-bold-duotone" className="size-5" />
						}
					>
						{t("basic.reset-filters")}
					</Button>
				)}
			</div>
		),
	};
};

let idx = 0;
export const baseTableRowProps = () => ({
	className:
		idx++ % 2
			? "bg-content1! hover:bg-content3!"
			: "bg-content2! hover:bg-content3!",
});
